module.exports = __webpack_public_path__ + "static/media/settings.6935f842.svg";